import { createInstance } from 'src/api';
import { appConfig } from 'src/lib/config';

const accessApi = createInstance({ baseURL: appConfig.accessApi });

export async function getKnownRoles() {
    const { data } = await accessApi.get<string[]>(`/roles/known`);
    return data;
}
